// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CommaFormat } from'../../../../elements/Price/Price'; 
import checkWarrantyImage from '../../../../assets/img/shopping-cart/check-warranty.png';

import style from './ItemCart.scss';

import type { ShoppingCartItem } from '../../../../entities';
import type { LocalValuesState } from '../../../local-values/duck';
import type { ForecastType } from '../../../new-order/ProductStep/components/NewProductForm/QuoteBox/ForecastBox/ForecastBox';


type Props = {
  item: ShoppingCartItem;
  type: ForecastType;
  localValues?: LocalValuesState;
  editItemError?: boolean;
  editShoppingCartItem: (itemNumber: number, amount?: number, shipping?: string) => void;
  deleteItem: (itemNumber: number) => void;
};

type State = {|
  quantity: string;
|};

export default class ItemCart extends Component<Props, State> {
  state = {
    quantity: this.props.item.amount,
  };

  hasCustoms = (item: ShoppingCartItem, type: ForecastType): boolean => {
    // console.log('type', type, item.forecastClassic);
    if (type === 'FULL' && item.forecastClassic) {
      // console.log('hasCustoms', item.forecastClassic);
      return item.forecastClassic.customsDuties === '0.00';
    }
    
    if (type === 'LITE' && item.forecastCourier) {
      // console.log('hasCustoms', item.forecastCourier);
      return item.forecastCourier.customsDuties === '0.00';
    }

    return false;
  };

  handleEditItem = (e: Event) => {
    const {item, editShoppingCartItem, editItemError} = this.props;

    if (e.target instanceof HTMLSelectElement) {
      const option = e.target.options[e.target.selectedIndex];      
      
      editShoppingCartItem(item.number, Number(option.value), item.shipping);

      if (!editItemError) {
        this.setState({quantity: option.value});
      }
    }
  };

  findCategoryDescription = (id: string) => {
    const {item, localValues} = this.props;
    const category = localValues && localValues.categories && localValues.categories.find((i) => id === i.id);
    return category ? category.translations.ES.name : '';
  };

  handleDeleteItem = () => {
    const {item, deleteItem} = this.props;
    deleteItem(item.number);
  };

  render() {
    const {item, type, localValues} = this.props;
    const {quantity} = this.state;

    const selectQuantity = 
    <select className={style.selectQuantityWrap} value={quantity} onChange={this.handleEditItem}>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
    </select>;

    return localValues &&  (
      <div className={style.itemCart}>
        <div className={style.dualWrap}>
          <div className={style.leftWrap}>
            <div className={style.contentWrap}>
              <div className={style.imageWrap}>
                <img src={item.image} alt={item.name}/>
              </div>
              <div className={style.informationWrap}>
                <div className={style.contentWrap}>
                  <span className={style.description}>{item.name}</span>
                  <span className={style.warranty}>
                    <img src={checkWarrantyImage} alt="Warranty image" width="16" height="16"/>
                    Garantía de 90 días gratis
                  </span>
                  <span className={style.moreInformation}>
                    Cantidad
                    {selectQuantity}
                  </span>
                  {type === 'LITE' && (
                    <span className={style.moreInformation}>Precio en USA: $ <CommaFormat price={item.price}/></span>    
                  )}
                  <span className={style.moreInformation}>
                    {`Categoría: ${this.findCategoryDescription(item.itemCategoryId)}`}
                  </span>
                  <button className={style.deleteButton} onClick={this.handleDeleteItem}>Eliminar</button>
                </div>
              </div>
            </div>
          </div>
          <div className={style.rightWrap}>
            <div className={style.contentWrap}>
              <div className={style.priceWrap}>
                {this.hasCustoms(item, type) && (<span className={style.chip}>Sin impuestos</span>)}
                {/* <Link className={style.link} to="/">Ver Detalle</Link> */}
              </div>
              <div className={style.mobileSectionWrap}>
                {this.hasCustoms(item, type) && (<span className={style.chip}>Sin impuestos</span>)}
                <button className={style.deleteButton} onClick={this.handleDeleteItem}>Eliminar</button>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    )
  }
}

ItemCart.propTypes = {
  item: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  localValues: PropTypes.object,
  editShoppingCartItem: PropTypes.func.isRequired,
  editItemError: PropTypes.bool,
  deleteItem: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/components/ItemCart/ItemCart.jsx